export class AcCourseCard extends HTMLElement {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "course", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    set data(c) {
        this.course = c;
        this.render();
    }
    render() {
        if (!this.course)
            return;
        this.style.display = "block";
        this.style.padding = "16px";
        this.style.borderRadius = "14px";
        this.style.background = "#12162a";
        this.style.border = "1px solid #2a2f4a";
        this.style.cursor = "pointer";
        this.innerHTML = `
          <div style="font-size:18px;font-weight:700">${this.course.title}</div>
          <div style="opacity:.75;margin-top:6px;font-size:14px">${this.course.blurb}</div>
        `;
    }
}
customElements.define("ac-course-card", AcCourseCard);
